/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2221 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

cartLineQuantityStyles.editableQuantityTextField = {
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.formInputWrapper")}
            width: 65px;
        `,
        inputSelect: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")}
            background: ${getColor("common.ui8")};
            font-size: 14px;
        `,
    },
    labelProps: {
        css: css`
            display: none;
        `,
    },
};

(cartLineQuantityStyles as any).readOnlyQuantityText = {
    extendedStyles: {
        heading: {
            css: css`
                display: none;
                ${screen("lte", 590)} {
                    display: block;
                }
            `,
        },
        text: {
            size: 16,
            lineHeight: "20px",
            weight: "bold",
            color: "common.ui10",
        },
    },
};
